
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/network",
      function () {
        return require("private-next-pages/profile/network/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/network"])
      });
    }
  